import BaseController from './BaseController'
import {
  action
} from 'mobx';

export default class FormController extends BaseController {

  @action async init(){
    this.viewModel.state = 'ReadOnly';
  }

  @action async load(){
    // 数据加载完进入修改状态
    await this.modify();
  }

  // 新增
  @action async create() {
    this.viewModel.state = 'AddNew';
  }
  // 加载数据
  @action async modify() {
    this.viewModel.state = 'Modify';
  }
  // 保存
  @action async save() {
    console.log('saving...');
    await this.dataModel.save();
    // 需要UI交互调用跨平台UI组件
    this.ui.feedback('保存成功','success');
  }
  // 上一张
  @action async pageUp() {

  }
  // 下一张
  @action async pageDown() {

  }

  //导入
  @action async importExcel() {

  }
  // 导出
  @action async exportExcel() {

  }
}
